import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { DynamicGrid } from '../../models/dynamic.model';

import { LazyLoadEvent, MessageService } from 'primeng/api';
import { NavigationService } from '../../services/navigation.service';
import { BaseListComponent } from '../../models/base/base-list.component';
import { ListService } from '../../services/list.service';
import { ActivatedRoute } from '@angular/router';
import { LookupService } from '../../services/lookup.service';
import { RowToolEvent, RowTools } from '../../models/row-tools.model';
import { SharedService } from '../../services/shared.service';
@Component({
  selector: 'quote-list',
  templateUrl: 'quote-list.component.html',
  providers: [ListService, LookupService],
  styles: [`
        :host ::ng-deep .ui-table .ui-table-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0;
            background: #EBEBEB;
            border-bottom: 1px solid #D8D8D8;
        }
`]
})
export class QuoteListComponent extends BaseListComponent implements OnInit, OnDestroy {
  lookups = {};

  showUserModal: boolean = false;
  showOrderModal: boolean = false;
  showLocationModal: boolean = false;
  @ViewChild("orderDialog", { static: false }) dialogRef: ElementRef;
  prevLazyLoadEvent: LazyLoadEvent | null = null;
  
  constructor(
    protected messageService: MessageService,
    private listService: ListService,
    private navigationService: NavigationService,
    private route: ActivatedRoute,
    private lookupService: LookupService,
    private sharedService: SharedService) {
    super();
  }

  ngOnInit() {
    this.class = 'quote';
    this.title = 'Quotes';

    this.model = new DynamicGrid<any>();

    this.rowTools = new RowTools();
    this.rowTools.addLink('edit', 'Edit');
    this.rowTools.addLink('view', 'View');

    //#region set nav state

    this.navigationService.showTopNav(true);
    this.navigationService.setTitle(this.title);
    this.navigationService.setLeftNav(null, 'quotes');
    this.navigationService.setButton('New Quote', 'new-order');
    this.navigationService.showButton(true);
    this.navigationService.showFilter(true, true);

    //#endregion

    //#region grid model

    this.model = new DynamicGrid<any>();

    //#endregion

    this.route.queryParams.subscribe(p => {
      if (p['preview'] != null && p['preview'] !== '') {
        this.view(p['preview']);
      }
    });

    this.subs['filter'] = this.navigationService.filter$.subscribe(s => {
      this.query = s;
      this.load();
    });

    this.subs['clickOrderButton'] = this.navigationService.clickNewOrder$.subscribe(s => {
      this.addOrder();
    });

    this.subs['clickUserButton'] = this.navigationService.clickNewUser$.subscribe(s => {
      this.addUser();
    });

    this.subs['clickButton'] = this.navigationService.clickButton$.subscribe(s => {
      this.add();
    });

    this.subs['clickLocationButton'] = this.navigationService.clickNewLocation$.subscribe(s => {
      this.addLocation();
    });

    this.loadLookup('yesNoPartial');
  }


  ngOnDestroy() {
    this.safeUnsub('clickOrderButton');
    this.safeUnsub('clickUserButton');
    this.safeUnsub('clickLocationButton');
    this.safeUnsub('filter');
  }

  lazyLoad(e: any) {
    if (this.prevLazyLoadEvent && this.sharedService.isSameEvent(e, this.prevLazyLoadEvent)) {
      return;
    }
    setTimeout(() => {
      this.prevLazyLoadEvent = e;
      this.setGridState(e);
      this.load();
    }, 0);
  }

  load() {
    if (this.isLoading)
      return;

    this.isLoading = true;
    this.model.rows = [];
    this.listService.quotes(this.params, this.query, this.first, this.rows, this.sortField, this.sortOrder)
      .subscribe(res => {
        this.loadColumns(res.body.metadata);
        this.model.rows = res.body.results;
        this.rowCount = res.body.count;
        this.isLoading = false;

        this.navigationService.setTitleAndSub({ title: this.title, subtitle: this.rowCount + ' total' });
      });
  }

  rowChangePreview(id: string) {
    if (this.navigationService.getNav().showRightNav) {
      this.navigationService.setRightNav('quote', id);
    }
  }

  loadLookup(key: string, force: boolean = false) {
    this.lookupService.get(key, force)
      .subscribe(r => {
        this.lookups[key] = r;
      });
  }

  clickRowTools(event: RowToolEvent) {
    this.selection = event.item;
    switch (event.key) {
      case 'view':
        this.view(event.item?.guid);
        break;
      case 'edit':
        this.edit(event.item);
        break;
    }
  }

  edit(row: any) {
    this.selection = row;
    this.showModal = true;
  }

  view(id: string) {
    this.navigationService.setDetail('quote', id);
  }

  add() {
    this.selection = null;
    this.showModal = true;
    this.showUserModal = false;
    this.showOrderModal = false;
    this.isAdding = true;
  }

  addUser() {
    this.showUserModal = true;
    this.showModal = false;
    this.showOrderModal = false;
  }

  addLocation(){
    this.showOrderModal = false;
    this.showUserModal = false;
    this.showLocationModal = true;
  }

  addOrder() {
    this.showUserModal = false;
    this.showModal = false;
    this.showOrderModal = true;
  }

  cancel() {
    this.showModal = false;
    this.showUserModal = false;
    this.showOrderModal = false;
    this.isEditing = false;
    this.isAdding = false;
    this.isDeleting = false;
    this.showLocationModal = false;
  }

  complete() {
    this.cancel();
    this.load();
  }
}
